module.exports = __webpack_public_path__ + "static/media/32.3eff2719.jpg";